/* Native Shopify form submission; JavaScript only enhances section controls. */
(() => {
  if (customElements.get('kushae-product')) return;

  function enhanceSelect(select, signal) {
    const wrapper = select.parentElement;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kp__select-toggle';
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', `${select.id}-listbox`);
    const label = document.createElement('span');
    toggle.append(label);
    const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('class', 'kp__chevron');
    arrow.setAttribute('viewBox', '0 0 11 18');
    arrow.setAttribute('width', '11');
    arrow.setAttribute('height', '18');
    arrow.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(arrow.namespaceURI, 'path');
    path.setAttribute('d', 'M8.98558 17.9712L0 8.98558L8.98558 0L10.0123 1.02669L2.05338 8.98558L10.0123 16.9445L8.98558 17.9712Z');
    path.setAttribute('fill', 'currentColor');
    arrow.append(path);
    toggle.append(arrow);
    const list = document.createElement('div');
    list.id = `${select.id}-listbox`;
    list.className = 'kp__listbox';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', select.getAttribute('aria-label'));
    list.tabIndex = -1;
    list.hidden = true;
    wrapper.append(toggle, list);
    select.hidden = true;
    let active = 0;
    let search = '';
    let searchAt = 0;
    const options = () => [...select.options];
    const close = (focus = false) => {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (focus) toggle.focus();
    };
    const highlight = index => {
      active = index;
      [...list.children].forEach((item, i) => { item.dataset.active = String(i === index); });
      const item = list.children[index];
      if (item) {
        list.setAttribute('aria-activedescendant', item.id);
        // Scroll only the listbox, never move the page while using a dropdown.
        if (item.offsetTop < list.scrollTop) list.scrollTop = item.offsetTop;
        if (item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) {
          list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;
        }
      }
    };
    const refresh = () => {
      label.textContent = select.selectedOptions[0]?.textContent || 'Select an option';
      toggle.setAttribute('aria-label', `${select.getAttribute('aria-label')}: ${label.textContent}`);
      // A disabled selling_plan select is intentionally still browsable for one-time buyers.
      toggle.disabled = options().length === 0;
      list.replaceChildren(...options().map((option, i) => {
        const item = document.createElement('div');
        item.className = 'kp__option';
        item.id = `${list.id}-${i}`;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', String(option.selected));
        item.setAttribute('aria-disabled', String(option.disabled));
        item.dataset.index = i;
        item.textContent = option.textContent;
        return item;
      }));
      highlight(Math.max(0, select.selectedIndex));
    };
    const open = () => {
      refresh();
      list.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      list.focus();
      highlight(Math.max(0, select.selectedIndex));
    };
    const choose = index => {
      if (!select.options[index] || select.options[index].disabled) return;
      select.selectedIndex = index;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      refresh();
      close(true);
    };
    toggle.addEventListener('click', () => list.hidden ? open() : close(), { signal });
    toggle.addEventListener('keydown', event => {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        open();
        if (event.key === 'End') highlight(select.options.length - 1);
        if (event.key === 'Home') highlight(0);
      }
    }, { signal });
    list.addEventListener('click', event => {
      const item = event.target.closest('[data-index]');
      if (item) choose(Number(item.dataset.index));
    }, { signal });
    list.addEventListener('keydown', event => {
      const count = select.options.length;
      if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' ', 'Escape'].includes(event.key)) event.preventDefault();
      if (event.key === 'ArrowDown') highlight((active + 1) % count);
      else if (event.key === 'ArrowUp') highlight((active - 1 + count) % count);
      else if (event.key === 'Home') highlight(0);
      else if (event.key === 'End') highlight(count - 1);
      else if (event.key === 'Enter' || event.key === ' ') choose(active);
      else if (event.key === 'Escape') close(true);
      else if (event.key === 'Tab') close();
      else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        search = Date.now() - searchAt > 700 ? event.key : search + event.key;
        searchAt = Date.now();
        const index = options().findIndex(option => option.textContent.trim().toLowerCase().startsWith(search.toLowerCase()));
        if (index >= 0) highlight(index);
      }
    }, { signal });
    document.addEventListener('pointerdown', event => {
      if (!wrapper.contains(event.target)) close();
    }, { signal });
    wrapper.addEventListener('focusout', event => {
      if (!wrapper.contains(event.relatedTarget)) close();
    }, { signal });
    select.addEventListener('change', refresh, { signal });
    signal.addEventListener('abort', () => { toggle.remove(); list.remove(); select.hidden = false; }, { once: true });
    refresh();
    return { refresh, close };
  }

  function initialize(root, signal) {
    const find = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const data = JSON.parse(find('[data-product-data]').textContent);
    const variantSelect = find('[data-variant]');
    const planSelect = find('[data-plan]');
    const once = find('[data-mode="once"]');
    const subscription = find('[data-mode="subscription"]');
    const quantity = find('[data-quantity]');
    const add = find('[data-add]');
    const slides = all('[data-media-id]');
    const thumbs = all('[data-thumbnail]');
    const models = all('model-viewer');
    if (models.length && window.Shopify?.loadFeatures) {
      if (!document.querySelector('[data-kp-model-styles]')) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
        stylesheet.dataset.kpModelStyles = '';
        document.head.append(stylesheet);
      }
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: error => {
        if (error || signal.aborted) return;
        const players = models.map(model => new window.Shopify.ModelViewerUI(model));
        signal.addEventListener('abort', () => players.forEach(player => player.destroy()), { once: true });
      } }]);
    }
    let mediaIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
    let variant = data.variants.find(item => item.id === variantSelect.value);
    let selectedPlan = planSelect?.value || '';
    let mode = subscription?.checked || variant?.requiresPlan ? 'subscription' : 'once';

    const showMedia = index => {
      if (!slides.length) return;
      mediaIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        if (i !== mediaIndex && !slide.hidden) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('model-viewer').forEach(model => model.pause?.());
          // Reload only a departing external player to reliably stop playback.
          slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
        }
        slide.hidden = i !== mediaIndex;
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === mediaIndex)));
      const thumb = thumbs[mediaIndex];
      if (thumb) {
        const track = thumb.parentElement;
        const left = thumb.offsetLeft - track.offsetLeft;
        if (left < track.scrollLeft) track.scrollLeft = left;
        if (left + thumb.offsetWidth > track.scrollLeft + track.clientWidth) track.scrollLeft = left + thumb.offsetWidth - track.clientWidth;
      }
      find('[data-gallery-status]').textContent = `Product media ${mediaIndex + 1} of ${slides.length}`;
    };
    const normalizeQuantity = () => {
      const min = Math.max(1, Number(quantity.min) || 1);
      const step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      let value = Math.max(min, Math.min(max, Number(quantity.value) || min));
      value = min + Math.floor((value - min) / step) * step;
      quantity.value = value;
      find('[data-quantity-step="-1"]').setAttribute('aria-disabled', String(value <= min));
      find('[data-quantity-step="1"]').setAttribute('aria-disabled', String(value + step > max));
    };
    const dropdowns = new Map(all('.kp__native').map(select => [select, enhanceSelect(select, signal)]));
    const update = (variantChanged = false) => {
      variant = data.variants.find(item => item.id === variantSelect.value);
      if (!variant) {
        add.disabled = true;
        add.textContent = 'UNAVAILABLE';
        return;
      }
      const plans = variant.plans || [];
      if (variant.requiresPlan) mode = 'subscription';
      else if (!plans.length) mode = 'once';
      once.disabled = Boolean(variant.requiresPlan);
      once.checked = mode === 'once';
      find('[data-one-time-row]').hidden = Boolean(variant.requiresPlan);
      if (subscription) {
        subscription.checked = mode === 'subscription';
        subscription.disabled = !plans.length;
        find('[data-subscription]').hidden = !plans.length;
        selectedPlan = plans.find(plan => plan.id === selectedPlan)?.id || plans[0]?.id || '';
        planSelect.replaceChildren(...plans.map(plan => new Option(plan.name, plan.id, false, plan.id === selectedPlan)));
        planSelect.disabled = mode !== 'subscription' || !plans.length;
        dropdowns.get(planSelect).refresh();
      }
      const plan = plans.find(item => item.id === selectedPlan);
      const price = mode === 'subscription' ? plan : variant;
      find('[data-price]').textContent = price?.priceWithCurrency || variant.priceWithCurrency;
      find('[data-once-price]').textContent = variant.priceWithCurrency;
      if (subscription) {
        find('[data-subscription-price]').textContent = plan?.priceWithCurrency || '';
        find('[data-plan-summary]').textContent = plan
          ? `${plan.name} · ${plan.priceWithCurrency}`
          : 'Select a delivery plan to view its details.';
        find('[data-plan-description]').hidden = !plan?.description;
        // Selling-plan descriptions are trusted merchant/app-authored Shopify HTML.
        find('[data-plan-description]').innerHTML = plan?.description || '';
      }
      add.disabled = !variant.available || !price;
      add.textContent = !variant.available ? 'SOLD OUT' : !price ? 'UNAVAILABLE' : `ADD TO BAG - ${price.price}`;
      quantity.min = Math.max(1, variant.quantityMin || 1);
      quantity.step = variant.quantityStep || 1;
      if (variant.quantityMax) quantity.max = variant.quantityMax;
      else quantity.removeAttribute('max');
      normalizeQuantity();
      if (variantChanged && variant.mediaId) {
        const index = slides.findIndex(slide => slide.dataset.mediaId === variant.mediaId);
        if (index >= 0) showMedia(index);
      }
    };
    root.addEventListener('change', event => {
      if (event.target === variantSelect) update(true);
      else if (event.target === planSelect) {
        selectedPlan = planSelect.value;
        mode = 'subscription';
        update();
      } else if (event.target.matches('[data-mode]')) {
        mode = event.target.dataset.mode;
        update();
      } else if (event.target === quantity) normalizeQuantity();
    }, { signal });
    const planDetails = find('[data-plan-details]');
    if (planDetails) {
      let mouseOverDetails = false;
      const placeDetails = () => {
        const trigger = planDetails.querySelector('summary').getBoundingClientRect();
        const panelHeight = planDetails.querySelector('.kp__details-panel').getBoundingClientRect().height;
        const spaceBelow = window.innerHeight - trigger.bottom;
        planDetails.dataset.placement = spaceBelow < panelHeight && trigger.top > spaceBelow ? 'top' : 'bottom';
      };
      planDetails.addEventListener('toggle', () => {
        if (planDetails.open) placeDetails();
      }, { signal });
      planDetails.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        mouseOverDetails = true;
        planDetails.open = true;
        placeDetails();
      }, { signal });
      planDetails.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        mouseOverDetails = false;
        if (!planDetails.contains(document.activeElement)) planDetails.open = false;
      }, { signal });
      planDetails.querySelector('summary').addEventListener('click', event => {
        // Keep the hover tooltip open; touch and keyboard retain native details toggling.
        if (mouseOverDetails) event.preventDefault();
      }, { signal });
      planDetails.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !planDetails.open) return;
        event.preventDefault();
        planDetails.open = false;
        planDetails.querySelector('summary').focus();
      }, { signal });
      planDetails.addEventListener('focusout', event => {
        if (!mouseOverDetails && !planDetails.contains(event.relatedTarget)) planDetails.open = false;
      }, { signal });
      document.addEventListener('pointerdown', event => {
        if (!planDetails.contains(event.target)) planDetails.open = false;
      }, { signal });
    }
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-thumbnail]');
      const arrow = event.target.closest('[data-gallery-step]');
      const step = event.target.closest('[data-quantity-step]');
      const reviewLink = event.target.closest('[data-scroll-to-reviews]');
      if (thumb) showMedia(thumbs.indexOf(thumb));
      if (arrow) showMedia(mediaIndex + Number(arrow.dataset.galleryStep));
      if (step) {
        if (step.getAttribute('aria-disabled') === 'true') return;
        normalizeQuantity();
        quantity.value = Number(quantity.value) + Number(step.dataset.quantityStep) * Number(quantity.step);
        normalizeQuantity();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (reviewLink) {
        document.querySelector('.kushae-ratings-reviews')?.scrollIntoView({ behavior: 'smooth' });
      }
    }, { signal });
    find('.kp__thumbnails')?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : mediaIndex + (event.key === 'ArrowRight' ? 1 : -1);
      showMedia(next);
      thumbs[mediaIndex]?.focus({ preventScroll: true });
    }, { signal });
    find('.kp__form').addEventListener('submit', event => {
      normalizeQuantity();
      if (add.disabled) event.preventDefault();
      // The standalone fixture never submits to a store.
      if (root.hasAttribute('data-debug')) {
        event.preventDefault();
        find('[data-status]').textContent = `Preview only: ${quantity.value} × ${variantSelect.selectedOptions[0].textContent}, ${mode === 'subscription' ? planSelect.selectedOptions[0].textContent : 'one-time purchase'}.`;
      }
    }, { signal });
    all('[data-enhanced]').forEach(element => { element.hidden = false; });
    update();
  }

  customElements.define('kushae-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      initialize(this, this.controller.signal);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
